import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  growerDetails: {},
};

export const growerSlice = createSlice({
  name: "grower",
  initialState,
  reducers: {
    addGrowerDetails: (state, action) => {
      state.growerDetails = action.payload;
    },

    removeGrowerDetails: (state) => {
      state.growerDetails = {};
    },
  },
});

// Action creators are generated for each case reducer function
export const { addGrowerDetails, removeGrowerDetails } = growerSlice.actions;

export default growerSlice.reducer;
